import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'PageIndex',
    component: () => import('../views/PageIndex.vue')
  },
  {
    path: '/PageType',
    name: 'PageType',
    component: () => import('../views/PageType.vue')
  },
  {
    path: '/PageUpdate',
    name: 'PageUpdate',
    component: () => import('../views/PageUpdate.vue')
  },
  {
    path: '/PageSearchTop',
    name: 'PageSearchTop',
    component: () => import('../views/PageSearchTop.vue')
  },
  {
    path: '/PageDetail',
    name: 'PageDetail',
    component: () => import('../views/PageDetail.vue')
  },
  {
    path: '/PagePlayer',
    name: 'PagePlayer',
    component: () => import('../views/PagePlayer.vue')
  },
  {
    path: '/PageSearch',
    name: 'PageSearch',
    component: () => import('../views/PageSearch.vue')
  },
  {
    path: '/PageView',
    name: 'PageView',
    component: () => import('../views/PageView.vue')
  },
  {
    path: '/PageLink',
    name: 'PageLink',
    component: () => import('../views/PageLink.vue')
  },
  {
    path: '/PageFIFA',
    name: 'PageFIFA',
    component: () => import('../views/PageFIFA.vue')
  },
  {
    path: '*',
    name: 'Page404',
    component: () => import('../views/Page404.vue')
  }
]

const router = new  VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


export default router
